// extracted by css-extract-rspack-plugin
export default {"cls1":"DoubleDigitCountBubble-cls1_gM6","cls2":"DoubleDigitCountBubble-cls2_l7J DoubleDigitCountBubble-cls1_gM6"};